import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin, Building2 } from 'lucide-react';
import './LegalPage.css';

export default function ImpressumPage() {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>📋 Impressum</h1>
        
        <section className="impressum-highlight">
          <h2>Angaben gemäß § 5 TMG / Art. 14 Abs. 1 UStG</h2>
          
          <div className="impressum-card">
            <Building2 size={24} className="impressum-icon" />
            <div>
              <h3>Betreiber</h3>
              <p>
                <strong>PedalScot</strong><br />
                [Ihr Firmenname / Name des Inhabers]<br />
                [Rechtsform: z.B. GmbH, e.K., Einzelunternehmer]
              </p>
            </div>
          </div>

          <div className="impressum-card">
            <MapPin size={24} className="impressum-icon" />
            <div>
              <h3>Anschrift</h3>
              <p>
                [Straße und Hausnummer]<br />
                [PLZ und Ort]<br />
                [Land: z.B. Deutschland, Schweiz, Österreich]
              </p>
            </div>
          </div>

          <div className="impressum-card">
            <Mail size={24} className="impressum-icon" />
            <div>
              <h3>Kontakt</h3>
              <p>
                E-Mail: <a href="mailto:info@pedalscot.com">info@pedalscot.com</a><br />
                Website: <a href="https://pedalscot.com" target="_blank" rel="noopener noreferrer">pedalscot.com</a>
              </p>
            </div>
          </div>

          <div className="impressum-card">
            <Phone size={24} className="impressum-icon" />
            <div>
              <h3>Telefon</h3>
              <p>[Ihre Telefonnummer]</p>
            </div>
          </div>
        </section>

        <section>
          <h2>Vertretungsberechtigte Personen</h2>
          <p>
            Geschäftsführung: [Name des Geschäftsführers / Inhabers]<br />
            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV: [Name]
          </p>
        </section>

        <section>
          <h2>Registereintrag</h2>
          <p>
            <strong>Handelsregister:</strong> [z.B. Amtsgericht München]<br />
            <strong>Registernummer:</strong> [z.B. HRB 123456]<br />
            <strong>Umsatzsteuer-ID:</strong> [z.B. DE123456789] (gemäß §27a Umsatzsteuergesetz)
          </p>
          <p className="info-box">
            ℹ️ <strong>Hinweis für Einzelunternehmer:</strong> Falls Sie kein Handelsregistereintrag haben, 
            entfernen Sie diesen Abschnitt.
          </p>
        </section>

        <section>
          <h2>Berufshaftpflichtversicherung</h2>
          <p>
            <strong>Versicherer:</strong> [Name der Versicherung]<br />
            <strong>Geltungsbereich:</strong> [z.B. Deutschland, EU-weit]
          </p>
        </section>

        <section>
          <h2>Haftungsausschluss</h2>
          
          <h3>Haftung für Inhalte</h3>
          <p>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit 
            und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir 
            gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. 
            Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder 
            gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine 
            rechtswidrige Tätigkeit hinweisen.
          </p>

          <h3>Haftung für Links</h3>
          <p>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. 
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </p>

          <h3>Urheberrecht</h3>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </section>

        <section>
          <h2>Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
              https://ec.europa.eu/consumers/odr
            </a>
          </p>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>

        <section>
          <h2>Bildnachweise & Credits</h2>
          <p>
            <strong>Icons:</strong> Lucide React (MIT License)<br />
            <strong>Karten:</strong> OpenStreetMap Contributors, Leaflet.js<br />
            <strong>Bilder:</strong> [Ihre Bildquellen / Lizenzangaben]
          </p>
        </section>

        <section className="legal-meta">
          <p>
            <strong>Zuletzt aktualisiert:</strong> Januar 2025<br />
            © 2025 PedalScot. Alle Rechte vorbehalten.
          </p>
        </section>
      </div>
    </div>
  );
}
